export const
  GET_INITIAL_DATA = 'GET_INITIAL_DATA',
  INITIAL_DATA = 'INITIAL_DATA',
  GET_WEEKLY_SLOTS = 'GET_WEEKLY_SLOTS',
  WEEKLY_SLOTS_RECEIVED = 'WEEKLY_SLOTS_RECEIVED',
  WEEKLY_SLOTS_ERROR = 'WEEKLY_SLOTS_ERROR',
  BOOK_SLOT = 'BOOK_SLOT',
  BOOK_SLOT_SUCCESSFUL = 'BOOK_SLOT_SUCCESSFUL',
  BOOK_SLOT_ERROR = 'BOOK_SLOT_ERROR',
  SELECTED_WEEK = 'SELECTED_WEEK',
  GET_SELECTED_WEEK = 'GET_SELECTED_WEEK',
  HANDLE_MODAL = 'HANDLE_MODAL',
  STATE = 'STATE'



// moment formatting
export const
  HOUR_MINUTE = 'HH:mm',
  INVERSED_DATE = 'YYYYMMDD',
  DAY_LONGMONTH = 'DD MMM',
  SLASHED_DATE = 'DD/MM/YYYY',
  LONG_DATE = 'dddd[,] D [de] MMMM [de] YYYY[,] H:mm'